import React, { useState, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Col, Table, Row, Form } from 'reactstrap';
import { HiPencil } from 'react-icons/hi';
import { MdDelete } from 'react-icons/md';
import { IoIosAdd } from 'react-icons/io';
import { useQueryClient } from 'react-query';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';

import './style.scss';
import AlertComponent from 'components/Alert';
import ButtonComponent from 'components/Buttons';
import InputField from 'components/Input/InputField';
import Loading from 'components/Loading';
import ModalComponent from 'components/Modal';
import SearchComponent from 'components/Search';
import Sidebar from './../Sidebar.js';
import {
  HTTP_EXPECTATION_FAILED,
  HTTP_INTERNAL_SERVER_ERROR,
  HTTP_OK,
  HTTP_NOT_ACCESS,
  HTTP_UNPROCESSABLE_ENTITY,
} from 'constants/StatusCode.js';
import { MAX_LENGTH_30 } from 'constants/index.js';
import { USE_LIST_CATEGORY_EMPLOYEES, ID_CATEGORY_EMPLOYEE_NOT_EDIT_AND_EDIT } from 'constants/MasterData';
import { useListCategoryEmployees } from 'hook/useMasterData.js';
import { apiCreateCategoryEmployees, apiDeleteCategoryEmployees, apiUpdateCategoryEmployees } from 'api/masterData.js';
import $ from 'jquery';
import { ThemContext } from 'layouts/Admin';
import { ROLE_VIEW, DISABLE_ROLE, DISABLE_BUTTON_ROLE } from 'constants/index.js';

const DEFAULT_FORM_DATA = {
  id: null,
  name: '',
  error_name: '',
};

const CategoryEmployees = () => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const dataInforUser = useContext(ThemContext);
  const [isShowModalAdd, setShowModalAdd] = useState(false);
  const [key_word, setKeyWord] = useState('');
  const [formAdd, setFormAdd] = useState(DEFAULT_FORM_DATA);
  const [isShowAlert, setShowAlert] = useState(false);
  const [message, setMessage] = useState('');
  const [disableBtn, setDisableBtn] = useState(false);
  const [textModal, setTextModal] = useState({
    title: t('masterData.addCategoryEmployees'),
    btn_submit: t('common.add'),
  });
  const { data: listCategoryEmployees, isLoading: isLoadingContract } = useListCategoryEmployees({ key_word });

  const handleSearch = (value) => {
    setKeyWord(value);
  };

  const addContract = () => {
    if (dataInforUser?.hr_permission?.master_data_permission === ROLE_VIEW) {
      return;
    }
    setShowModalAdd(true);
    setFormAdd({ ...formAdd, id: null, name: '', error_name: '' });
    setTextModal({
      title: t('masterData.addCategoryEmployees'),
      btn_submit: t('common.add'),
    });
  };

  const handleInput = (e) => {
    let _error = {};
    if (e.target.value) {
      _error = { ['error_' + e.target.name]: '' };
    }

    setFormAdd({ ...formAdd, [e.target.name]: e.target.value, ..._error });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setDisableBtn(true);
    var focus = true;
    setFormAdd({ ...formAdd, error_name: '' });

    if (!formAdd.name) {
      setFormAdd({ ...formAdd, error_name: t('common.pleaseFillOutThisField') });
      if (focus) {
        $('input[name=name]').focus();
        focus = false;
      }
      setDisableBtn(false);
      return;
    }
    if (formAdd.name.length > MAX_LENGTH_30) {
      setFormAdd({ ...formAdd, error_name: t('common.pleaseEnterLessThanThirtyCharacters') });
      if (focus) {
        $('input[name=name]').focus();
        focus = false;
      }
      setDisableBtn(false);
      return;
    }

    const data = {
      name: formAdd.name,
    };

    let response = {};
    if (!formAdd.id) {
      response = await apiCreateCategoryEmployees(data);
    } else {
      response = await apiUpdateCategoryEmployees(formAdd.id, data);
    }
    if (response?.status === HTTP_UNPROCESSABLE_ENTITY) {
      if (response.data.messages?.name) {
        if (focus) {
          $('input[name=name]').focus();
          focus = false;
        }
        setFormAdd({ ...formAdd, error_name: response.data.messages.name[0] });
      }
      setDisableBtn(false);
      return;
    }
    if (response?.data?.status === HTTP_NOT_ACCESS && response?.data?.is_edit) {
      setMessage(t('common.pleaseCheckAgainYouAreNotAuthorizedToUseThisFeature'));
      setShowAlert(true);
    }
    if (response?.data?.status === HTTP_OK) {
      setShowModalAdd(false);
      setMessage(response.data.messages);
      setShowAlert(true);
      queryClient.invalidateQueries(USE_LIST_CATEGORY_EMPLOYEES);
    }

    if (response?.status === HTTP_INTERNAL_SERVER_ERROR || response?.data.status === HTTP_EXPECTATION_FAILED) {
      setMessage(response.data.messages);
      setShowAlert(true);
      queryClient.invalidateQueries(USE_LIST_CATEGORY_EMPLOYEES);
    }
    setDisableBtn(false);
  };

  const alertConfirm = (id) => {
    if (dataInforUser?.hr_permission?.master_data_permission === ROLE_VIEW) {
      return;
    }
    confirmAlert({
      title: t('common.doYouWantToDeletedData?'),
      buttons: [
        {
          label: t('common.cancel'),
          className: 'btn-alert-cancel',
        },
        {
          label: t('common.ok'),
          className: 'btn-alert-ok',
          onClick: async () => {
            const response = await apiDeleteCategoryEmployees(id);
            if (response?.data?.status === HTTP_NOT_ACCESS && response?.data?.is_edit) {
              setMessage(t('common.pleaseCheckAgainYouAreNotAuthorizedToUseThisFeature'));
              setShowAlert(true);
            }
            if (response.data.status === HTTP_OK) {
              setMessage(response.data.messages);
              setShowAlert(true);
              queryClient.invalidateQueries(USE_LIST_CATEGORY_EMPLOYEES);
            }
            if (
              response?.data.status === HTTP_INTERNAL_SERVER_ERROR ||
              response?.data.status === HTTP_EXPECTATION_FAILED
            ) {
              setMessage(response?.data?.messages);
              setShowAlert(true);
              queryClient.invalidateQueries(USE_LIST_CATEGORY_EMPLOYEES);
            }
          },
        },
      ],
    });
  };

  const handleEdit = (CategoryEmployees) => {
    if (dataInforUser?.hr_permission?.master_data_permission === ROLE_VIEW) {
      return;
    }
    setFormAdd({
      ...formAdd,
      id: CategoryEmployees.id,
      name: CategoryEmployees.name,
      error_name: '',
    });
    setTextModal({ ...textModal, title: t('masterData.updateCategoryEmployees'), btn_submit: t('common.update') });
    setShowModalAdd(!isShowModalAdd);
  };

  return (
    <div>
      <Row>
        <Col lg={3} xl={2}>
          <Sidebar />
        </Col>
        <Col lg={9} xl={10}>
          <Row>
            <Col className="md-12">
              <div className="box-group d-flex float-right">
                <SearchComponent
                  txtPlaceholder={t('masterData.findData')}
                  addClass="input-search"
                  handleSearch={handleSearch}
                  defaultValue={key_word}
                />
                <ButtonComponent
                  text={t('common.add')}
                  icon={<IoIosAdd />}
                  addClass={`${
                    dataInforUser?.hr_permission?.master_data_permission === ROLE_VIEW && DISABLE_BUTTON_ROLE
                  } ml-3`}
                  handleClick={addContract}
                />
              </div>
            </Col>
          </Row>
          <Row className="mt-3">
            <Col className="md-12">
              <div className="table-list">
                <Table className="align-items-center table-hover" responsive>
                  <thead>
                    <tr>
                      <th scope="col">{t('masterData.categoryEmployeesCode')}</th>
                      <th scope="col">{t('masterData.categoryEmployees')}</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {listCategoryEmployees &&
                      listCategoryEmployees.map((item) => (
                        <tr key={item.id}>
                          <td>{item.id}</td>
                          <td className="text-bold">{item.name}</td>
                          <td>
                            {ID_CATEGORY_EMPLOYEE_NOT_EDIT_AND_EDIT.indexOf(item.id) < 0 && (
                              <div className="col-action d-flex float-right">
                                <div
                                  className={`${
                                    dataInforUser?.hr_permission?.master_data_permission === ROLE_VIEW && DISABLE_ROLE
                                  } edit mr-2`}
                                >
                                  <HiPencil onClick={() => handleEdit(item)}></HiPencil>
                                </div>
                                <div
                                  className={`${
                                    dataInforUser?.hr_permission?.master_data_permission === ROLE_VIEW && DISABLE_ROLE
                                  } remove mr-3`}
                                >
                                  <MdDelete onClick={() => alertConfirm(item.id)}></MdDelete>
                                </div>
                              </div>
                            )}
                          </td>
                        </tr>
                      ))}
                    {isLoadingContract && (
                      <tr>
                        <td colSpan={3}>
                          <Loading addClass="mt-2" />
                        </td>
                      </tr>
                    )}
                    {!isLoadingContract &&
                      (!listCategoryEmployees || (listCategoryEmployees && !listCategoryEmployees.length)) && (
                        <tr>
                          <td colSpan={3} className="error-no-data">
                            {t('common.notData')}
                          </td>
                        </tr>
                      )}
                  </tbody>
                </Table>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>

      <ModalComponent
        toggle={() => setShowModalAdd(!isShowModalAdd)}
        isShowModal={isShowModalAdd}
        title={textModal.title}
      >
        <Form className="mt-3 box-show-none" onSubmit={handleSubmit}>
          <InputField
            label={t('masterData.categoryEmployeesName')}
            isRequired={true}
            variant="outlined"
            name="name"
            defaultValue={formAdd.name}
            onHandleInput={handleInput}
            maxLength={MAX_LENGTH_30}
            error={formAdd.error_name}
          />

          <Row className="mt-5">
            <Col className="md-6">
              <ButtonComponent
                text={t('common.cancel')}
                addClass="w-100 btn-bg-yellow2"
                handleClick={() => setShowModalAdd(false)}
              />
            </Col>
            <Col className="md-6">
              <ButtonComponent
                text={textModal.btn_submit}
                addClass="w-100"
                handleClick={() => setShowModalAdd(true)}
                type="submit"
                hasDisabled={disableBtn}
                isLoading={disableBtn}
              />
            </Col>
          </Row>
        </Form>
      </ModalComponent>

      <AlertComponent toggle={() => setShowAlert(!isShowAlert)} isShowAlert={isShowAlert}>
        {message}
      </AlertComponent>
    </div>
  );
};

export default CategoryEmployees;
